(() => {
  const STORAGE_KEY = 'terraverde_wishlist';

  const getWishlist = () => {
    try {
      const data = JSON.parse(localStorage.getItem(STORAGE_KEY));
      return Array.isArray(data) ? data : [];
    } catch (error) {
      return [];
    }
  };

  const saveWishlist = (wishlist) => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(wishlist));

    document.dispatchEvent(
      new CustomEvent('terraverde:wishlist:updated', {
        detail: {
          wishlist,
          count: wishlist.length
        }
      })
    );
  };

  const isWishlisted = (handle) => {
    return getWishlist().includes(handle);
  };

  const addToWishlist = (handle) => {
    if (!handle) return;

    const wishlist = getWishlist();

    if (!wishlist.includes(handle)) {
      wishlist.push(handle);
      saveWishlist(wishlist);
    }
  };

  const removeFromWishlist = (handle) => {
    if (!handle) return;

    const wishlist = getWishlist().filter(
      (item) => item !== handle
    );

    saveWishlist(wishlist);
  };

  const toggleWishlist = (handle) => {
    if (isWishlisted(handle)) {
      removeFromWishlist(handle);
      return false;
    }

    addToWishlist(handle);
    return true;
  };

  const updateButton = (button) => {
    const handle = button.dataset.productHandle;
    const active = isWishlisted(handle);

    button.classList.toggle('is-active', active);

    button.setAttribute(
      'aria-pressed',
      active ? 'true' : 'false'
    );

    const text = button.querySelector(
      '[data-wishlist-text]'
    );

    if (text) {
      text.textContent = active
        ? 'Added to Wishlist'
        : 'Add to Wishlist';
    }
  };

  const updateAllButtons = () => {
    document
      .querySelectorAll('[data-wishlist-button]')
      .forEach(updateButton);

    const count = getWishlist().length;

    document
      .querySelectorAll('[data-wishlist-count]')
      .forEach((counter) => {
        counter.textContent = count;
        counter.hidden = count === 0;
      });
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest(
      '[data-wishlist-button]'
    );

    if (!button) return;

    event.preventDefault();

    const handle = button.dataset.productHandle;

    if (!handle) return;

    toggleWishlist(handle);
    updateAllButtons();
  });

  document.addEventListener(
    'terraverde:wishlist:updated',
    updateAllButtons
  );

  document.addEventListener(
    'DOMContentLoaded',
    updateAllButtons
  );

  window.TerraverdeWishlist = {
    get: getWishlist,
    add: addToWishlist,
    remove: removeFromWishlist,
    toggle: toggleWishlist,
    has: isWishlisted,
    refresh: updateAllButtons
  };
})();